import Brightcove from './brightcove';

const Plyr = require('plyr');

export default class LoadVideos {
  constructor() {
    this.videoClass = '.ann-bc-video';
    this.brightcove = new Brightcove();
  }

  init() {
    this.loadVideos();
  }

  loadVideos() {
    document.querySelectorAll(this.videoClass).forEach((video) => {
      const videoId = video.getAttribute('data-video-id');
      this.brightcove.getBrightcoveVideoData(videoId)
        .then(data => this.videoLoaded(data.video, data.poster, video, videoId))
        .catch(err => console.log(`video-error: ${err}`));
    });
  }

  videoLoaded(video, poster, element, videoId) {
    let videoSettings = 'loop playsinline muted autoplay';
    if (element.getAttribute('data-video-settings')) {
      videoSettings = element.getAttribute('data-video-settings');
    }

    let videoControls = '';
    if (element.getAttribute('data-video-controls') === 'true') {
      videoControls = 'controls';
    }

    element.innerHTML = `
    <video id="v${videoId}" ${videoControls} ${videoSettings} poster="${poster}">
      <source src="${video}" type="video/mp4">
    </video>
    `;

    if (element.getAttribute('data-plyr') === 'true') {
      const controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'];
      const player = new Plyr(document.getElementById(`v${videoId}`), { controls });
      console.log(`150-player-loaded ${player}`);
    }
  }
}



// WEBPACK FOOTER //
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_bcom/package/src/js/loadVideos.js